var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-sm btn-danger transition-3d-hover",attrs:{"href":"#"},on:{"click":_vm.logout}},[_vm._v("Se déconnecter")])}
var staticRenderFns = []

export { render, staticRenderFns }